import { ReactNode } from "react";
import { Colors, fontXLarge } from "main";

type IconBlockGroupProps = {
  title?: string;
  children: ReactNode;
};

export function IconBlockGroup(props: IconBlockGroupProps) {
  const { children, title } = props;

  return (
    <div>
      {!!title && <h2 css={{ margin: 0, marginBottom: 16, ...fontXLarge() }}>{title}</h2>}
      <div css={{ borderRadius: 8, backgroundColor: Colors.white200 }}>{children}</div>
    </div>
  );
}
